'use strict';

var d3 = require('d3');
var _ = require('lodash');
var drawUtils = require('../utils/drawUtils');
var toolTipHandler = require('../utils/toolTipHandler');

var d3CHS = require('./d3_cohortSelector');
var continuousColumn = require('./d3_PP_ContinuousColumn');
var categoryColumn = require('./d3_PP_CategoryColumn');

var filterHandler = require('./d3_PP_FilterHandler');

var d3Warning = require('./d3_PP_Warning');

var ppPathsRender = void 0; //is set by the graphType in D3PP.create()

function d3ParallelPlot() {

  var D3PP = {};

  D3PP.create = function (el, environment, graphType) {

    //To DO --> Set environment swwitch function       
    D3PP.environment = environment;
    if (environment === 'ISPM') {
      toolTipHandler = require('../utils/toolTipHandlerISPM');
    } else {
      toolTipHandler = require('../utils/toolTipHandler');
    }

    D3PP.graphProps = {};
    D3PP.graphProps.global = {};

    D3PP.graphProps.global['padding'] = Number(d3.select("#container-paralellplot").style('padding').slice(0, -2));

    D3PP.graphProps.global.margins = { top: 12, right: 48, bottom: 12, left: 48, offSetX: 0 };

    D3PP.graphProps.graph = {};
    D3PP.graphProps.graph.columns = { top: 150, height: 300, width: 18, innerPadding: 240 };
    D3PP.graphProps.graph.cohortSelector = {
      top: 64,
      rXY: 12,
      width: 340,
      canvasHeight: 460,
      height: D3PP.graphProps.graph.columns.height
    };

    D3PP.graphProps.graph.trash = { x: 0, y: -20, width: 48, height: 360 };

    D3PP.graphProps.header = { x: 16, y: 32 };
    D3PP.graphProps.footer = { x: 24, y: null };

    D3PP.onDragAllowed = false;
    D3PP.interval = null;
    D3PP.fps = Math.round(1000 / 30);

    D3PP.columnBrushes = {};

    D3PP.svgContainer = d3.select(el);

    //set canvas
    D3PP.canvas = D3PP.svgContainer.append('canvas').attr('id', 'htmlCanvas').style('position', 'absolute');

    D3PP.virtualDom = document.createElement("custom");
    D3PP.virtualDomContainer = d3.select(D3PP.virtualDom);

    D3PP.svg = D3PP.svgContainer.append('svg').attr('id', 'svgPP').style('position', 'absolute');

    D3PP.svg.gGraph = D3PP.svg.append('g').attr('id', 'gGraph');

    D3PP.svg.gGraph.cohortSelector = D3PP.svg.gGraph.append('g').attr('id', 'gCohort').attr("transform", "translate(" + 0 + "," + D3PP.graphProps.graph.columns.top + ")");

    D3PP.svg.gGraph.cohortSelector.bckgr = D3PP.svg.gGraph.cohortSelector.append('rect').attr('id', 'cohort-bckgr').attr('x', -D3PP.graphProps.graph.cohortSelector.rXY).attr('width', D3PP.graphProps.graph.cohortSelector.width + D3PP.graphProps.graph.cohortSelector.rXY).attr('height', D3PP.graphProps.graph.cohortSelector.height + D3PP.graphProps.graph.cohortSelector.rXY).attr("rx", D3PP.graphProps.graph.cohortSelector.rXY).attr("ry", D3PP.graphProps.graph.cohortSelector.rXY).attr('opacity', 0.25).attr('fill', '#f5f5f5');

    D3PP.svg.gGraph.trash = D3PP.svg.gGraph.append('g').attr('id', 'gTrash').attr('visibility', 'hidden');
    D3PP.svg.gGraph.trash.append('rect').attr('id', 'trash-rect').attr('width', D3PP.graphProps.graph.trash.width).attr('height', D3PP.graphProps.graph.trash.height).attr('rx', 6).attr('ry', 6).attr('fill', '#212121').attr('stroke', drawUtils.colors.signals.warning);

    D3PP.svg.gGraph.trash.append('svg:foreignObject').attr("width", 32).attr("height", 32).attr('y', D3PP.graphProps.graph.columns.height / 2 - 12).attr('x', 10).attr('opacity', 0.75).append("xhtml:div").style('background-color', 'none').style('color', '#212121').style('cursor', 'default').html(function () {
      var icon = '<i class="iconfont-dls-16"></i>';
      if (D3PP.environment === 'ISPM') icon = '<i class="icon__DeleteTrash"></i>';
      return icon;
    });

    D3PP.svg.gGraph.catRelations = D3PP.svg.gGraph.append('g').attr('id', 'gRelations');
    D3PP.svg.gGraph.svgSplines = D3PP.svg.gGraph.append('g').attr('id', 'gSplines');
    D3PP.svg.gGraph.columns = D3PP.svg.gGraph.append('g').attr('id', 'gColumns');

    D3PP.svg.gGraph.gHeader = D3PP.svg.append('g').attr('id', 'gHeader');
    // D3PP.svg.gGraph.gFooter = D3PP.svg.append('g').attr('id', 'gFooter');

    // select div for the tooltip
    D3PP.toolTip = d3.select("#tooltip");
    D3PP.toolTip.minimal = D3PP.toolTip.select('#minimal');
    D3PP.toolTip.minimal.pointer = D3PP.toolTip.minimal.select('#pointer');
    D3PP.toolTip.minimal.htmlContent = D3PP.toolTip.minimal.select('#htmlContent');
    D3PP.removeToolTip(); // hide tooltip by default

    D3PP.scaleX = d3.scaleBand().paddingOuter(1).paddingInner(0);

    // set the right class for patients rendering
    D3PP.graphType = 'parallelPlot';
    if (graphType) D3PP.graphType = graphType;
    if (graphType === 'parallelPlot') {
      ppPathsRender = require('./d3_PP_PatientsPaths');
    } else {
      ppPathsRender = require('./d3_PP_SankeyPaths');
    }

    var pathRenderProps = {
      cohortSelector: false,
      d3CHS: d3CHS,
      showToolTip: D3PP.showToolTip,
      toolTipPosition: D3PP.toolTipPosition,
      removeToolTip: D3PP.removeToolTip

    };
    ppPathsRender.constructor(pathRenderProps);

    D3PP.reSize(el, null, false);

    d3.select("#charts-separator-down").attr('title', 'Split View').on('click', function () {
      D3PP.toggleChartsVisibility('down');
    });

    d3.select("#charts-separator-up").attr('title', 'Hide Graph').on('click', function () {
      D3PP.toggleChartsVisibility('up');
    });
  };

  D3PP.reSize = function (el, dataColumns, cohortSelector) {
    D3PP.graphProps.global.width = el.offsetWidth;
    D3PP.graphProps.global.height = el.offsetHeight;
    D3PP.graphProps.global.left = 117;

    // D3PP.graphProps.global.margins.offSetX = D3PP.graphProps.global.left;// D3PP.graphProps.global.width / 2;

    D3PP.graphProps.graph.width = D3PP.graphProps.global.width - D3PP.graphProps.global.margins.left - D3PP.graphProps.global.margins.right;

    D3PP.graphProps.graph.cohortSelector.canvasHeight = D3PP.graphProps.global.height - D3PP.graphProps.graph.columns.top + D3PP.graphProps.graph.cohortSelector.top + D3PP.graphProps.graph.cohortSelector.rXY;
    D3PP.svg.gGraph.cohortSelector.bckgr.attr('height', D3PP.graphProps.graph.cohortSelector.canvasHeight).attr('y', -D3PP.graphProps.graph.cohortSelector.top);

    if (cohortSelector) {

      ppPathsRender.cohortSelector = true;

      D3PP.graphProps.graph.width = D3PP.graphProps.graph.width - D3PP.graphProps.graph.cohortSelector.width;
      D3PP.svg.gGraph.cohortSelector.attr("transform", "translate(" + 0 + "," + 0 + ")");
    } else {
      D3PP.svg.gGraph.cohortSelector.style("display", "none"); //.attr("transform", "translate(" + (-D3PP.graphProps.graph.cohortSelector.width) + "," + 0 + ")");
    }

    var wGraph = 0;
    var wCanvas = 0;
    if (dataColumns) {
      var xDomain = dataColumns.map(function (d) {
        return d.column.id;
      });

      D3PP.scaleX.domain(xDomain).range([0, D3PP.graphProps.graph.width]);
      D3PP.graphProps.graph.columns.innerPadding = Math.floor(D3PP.scaleX.bandwidth());

      var xMin = 0;
      var xMax = 0;
      if (dataColumns[0]) {
        xMin = D3PP.scaleX(dataColumns[0].column.id);
        xMax = D3PP.scaleX(dataColumns[dataColumns.length - 1].column.id);
      }

      wGraph = xMax - xMin;
      wCanvas = wGraph + D3PP.graphProps.graph.columns.innerPadding;

      D3PP.graphProps.global.margins.offSetX = D3PP.graphProps.global.left; //(D3PP.graphProps.global.width / 2) - (wGraph / 2) - D3PP.graphProps.graph.columns.innerPadding;

      if (cohortSelector) D3PP.graphProps.global.margins.offSetX += D3PP.graphProps.graph.cohortSelector.width / 2;
    }

    //console.log('inner padding :',D3PP.graphProps.graph.columns.innerPadding)

    var dpi = window.devicePixelRatio;

    D3PP.context = D3PP.canvas.node().getContext('2d');

    var canvasWidth = D3PP.graphProps.global.width - D3PP.graphProps.global.left;
    var canvasHeight = D3PP.graphProps.global.height - D3PP.graphProps.graph.columns.top;

    D3PP.canvas.attr('width', canvasWidth * dpi + 'px').attr('height', canvasHeight * dpi + 'px').style('width', canvasWidth + 'px').style('height', canvasHeight + 'px').style('top', D3PP.graphProps.graph.columns.top + D3PP.graphProps.global.padding + 'px').style('left', D3PP.graphProps.global.left + 'px');

    D3PP.context.scale(dpi, dpi);

    D3PP.svg.attr("width", D3PP.graphProps.global.width + 'px').attr("height", D3PP.graphProps.global.height + 'px');

    D3PP.svg.gGraph.attr("transform", "translate(" + D3PP.graphProps.global.left + "," + D3PP.graphProps.graph.columns.top + ")");

    D3PP.graphProps.graph.trash.xActive = D3PP.graphProps.global.width - 40;
    D3PP.graphProps.graph.trash.xInActive = D3PP.graphProps.global.width;

    D3PP.svg.gGraph.trash.attr("transform", "translate(" + (D3PP.graphProps.global.left + D3PP.graphProps.graph.trash.xInActive) + "," + D3PP.graphProps.graph.trash.y + ")");

    D3PP.svg.gGraph.gHeader.attr("transform", "translate(" + D3PP.graphProps.header.x + "," + D3PP.graphProps.header.y + ")");

    D3PP.graphProps.footer.y = D3PP.graphProps.global.height - 32;
    //D3PP.svg.gGraph.gFooter.attr("transform", "translate(" + D3PP.graphProps.footer.x + "," + D3PP.graphProps.footer.y + ")");
  };

  D3PP.update = function (el, props) {

    if (!props.updateType) return;

    //console.log('D3PP props :',props)

    if (el) D3PP.domEl = el;

    D3PP.reportUpdate = props.reportUpdate;

    if (props.updateType === 'filter') {
      D3PP.validationWarnings.invalidInput = false;
      D3PP.similarPatientsFilter.filtersActive = props.filtersActive;
      D3PP.updateColumns(D3PP.tweenTime, true, props.vertexUpdate);
      return;
    };

    //clear svg path plotdata
    _.each(D3PP.patientsIdMap, function (d) {
      d.paralelPlot.path = [];
    });

    if (props.updateType === 'reSize') {
      D3PP.reSize(D3PP.domEl, D3PP.dataParallelPlot, D3PP.cohortSelector);
      D3PP.updateColumns(0, false, true);
      return;
    }

    //TODO beter update function for performance
    if (props.updateType === 'updateColumnConfigurations') {
      D3PP.validationWarnings.patientIsOutlier = false;

      D3PP.dataConfig = props.data.config;
      D3PP.dataParallelPlot = D3PP.updateColumnConfiguration(props);
    }

    if (props.updateType === 'init') {
      D3PP.realTimeUpdate = props.realTimeUpdate;
      D3PP.tweenTime = props.tweenTime;
      D3PP.dataParallelPlot = D3PP.initPlot(props);
    }

    if (props.updateType === 'cohortSelectionUpdate') {
      D3PP.dataConfig = props.data.config;
      D3PP.updateCohortSelection(props);
    }

    D3PP.reSize(D3PP.domEl, D3PP.dataParallelPlot, D3PP.cohortSelector);

    _.each(D3PP.dataParallelPlot, function (data, i) {
      D3PP.setColumnsData(data, i);
    });

    D3PP.vertexUpdate = true;
    D3PP.updateColumns(D3PP.tweenTime, true, true);
  };

  D3PP.initPlot = function (props) {

    //set state evnet listeners
    D3PP.onFilterUpdate = props.onFilterUpdate;
    D3PP.onColumnConfigUpdate = props.onColumnConfigUpdate;
    D3PP.dataConfig = props.data.config;

    //D3PP.dataConfigconsole.log(D3PP.dataConfig);

    //set data model
    D3PP.cohortSelector = null;
    if (props.data.config.cohortSelector) D3PP.cohortSelector = props.data.config.cohortSelector;

    D3PP.reportUpdate = props.reportUpdate;
    D3PP.patientsIdMap = props.data.patientsIdMap;
    D3PP.totalNRPatients = props.data.totalNRPatients;

    D3PP.similarPatientsFilter = {
      columnSelection: {},
      columnPatients: {},
      brushedSelection: {},
      brushedPatients: {},
      patients: [],
      patientsIdMap: {},
      minSampleSize: 30
    };

    if (D3PP.dataConfig.minSampleSize) D3PP.similarPatientsFilter.minSampleSize = D3PP.dataConfig.minSampleSize;

    D3PP.activePatient = null;
    if (props.data.activePatient) D3PP.activePatient = props.data.activePatient;

    D3PP.validationWarnings = props.data.validationWarnings;

    //create pre filter configuration
    D3PP.preFilterConfigurations = { inited: false, categories: [], brushes: [] };

    var dataParallelPlot = [];
    _.each(props.data.parallelPlot, function (d) {

      if (d.active) {
        if (D3PP.graphType === 'parallelPlot') {
          dataParallelPlot.push(d);
        } else if (D3PP.graphType === 'sankey' && d.scale.scaling === 'categorical') {
          dataParallelPlot.push(d);
        }
      }

      if (d.filters) {
        if (d.filters.categories) {
          _.each(d.filters.categories, function (c) {
            var cat = _.find(d.column.categories, function (o) {
              return o.category === c;
            });
            D3PP.preFilterConfigurations.categories.push(cat);
          });
        } else {
          D3PP.preFilterConfigurations.brushes.push(d);
        }
      }
    });

    _.each(dataParallelPlot, function (d, i) {
      d.order = i;
    });
    dataParallelPlot = _.sortBy(dataParallelPlot, function (d) {
      return d.order;
    });

    // console.log('config :',props.data.config)
    // debugger;
    if (props.data.config.cohortSelector) {
      d3CHS.initCHS(D3PP.svg.gGraph.cohortSelector, props.data.config.cohortSelector.header, D3PP.graphProps.graph.cohortSelector, props.onCohortUpdate);
      D3PP.updateCohortSelection(props);
    }
    ;

    return dataParallelPlot;
  };

  D3PP.updateCohortSelection = function (props) {

    var cohortColumn = _.find(props.data.parallelPlot, function (c) {
      return c.column.id === props.data.config.cohortSelector.column.id;
    });

    props.data.config.cohortSelector.column = cohortColumn.column;

    d3CHS.updateCHS(D3PP.svg.gGraph.cohortSelector, props.data.config.cohortSelector, D3PP.graphProps.graph.cohortSelector, props.data.patients.length, props.tweenTime);
  };

  D3PP.updateColumnConfiguration = function (props) {

    console.log('updateColumnConfiguration :', props.updatedColumnConfig);
    _.each(props.updatedColumnConfig, function (cc) {

      var column = _.find(D3PP.dataParallelPlot, function (d) {
        return d.column.id === cc.column.id;
      });

      if (cc.active) {

        if (column) return;
        var newColumn = _.find(props.data.parallelPlot, function (d) {
          return d.column.id === cc.column.id;
        });

        newColumn.active = true;
        newColumn.order = D3PP.dataParallelPlot.length + 1;
        D3PP.dataParallelPlot.push(newColumn);
      } else {
        if (!column) return;

        var oldColumn = _.find(D3PP.dataParallelPlot, function (d) {
          return d.column.id === cc.column.id;
        });
        oldColumn.active = false;

        D3PP.dataParallelPlot = _.remove(D3PP.dataParallelPlot, function (d) {
          return d.column.id !== oldColumn.column.id;
        });

        var filterUpdate = false;
        if (oldColumn.dataCategories) {
          if (D3PP.similarPatientsFilter.columnSelection[oldColumn.column.id]) delete D3PP.similarPatientsFilter.columnSelection[oldColumn.column.id];
          if (D3PP.similarPatientsFilter.columnPatients[oldColumn.column.id]) {
            delete D3PP.similarPatientsFilter.columnPatients[oldColumn.column.id];
            filterUpdate = true;
          }
        } else {
          if (D3PP.similarPatientsFilter.brushedSelection[oldColumn.column.id]) delete D3PP.similarPatientsFilter.brushedSelection[oldColumn.column.id];
          if (D3PP.similarPatientsFilter.brushedPatients[oldColumn.column.id]) {
            delete D3PP.similarPatientsFilter.brushedPatients[oldColumn.column.id];
            filterUpdate = true;
          }
        }

        if (filterUpdate) {
          D3PP.setSimilarPatientsFilter(true, 250, true);
        }
      }
      ;
    });
    return D3PP.dataParallelPlot;
  };

  D3PP.setColumnsData = function (data, index) {

    data.resetFliterBtn = { visibility: 'hidden', action: null };

    if (!data.column.categories) {

      var extent = d3.extent(data.column.patients, function (p) {
        if (!isNaN(p.value)) {
          return p.value;
        }
      });
      //console.log('extent :',extent);

      // set NA category column
      data.column['NA'] = { value: null, perc: 0, height: 0, y: 0, parseNumber: null };

      _.each(data.column.patients, function (p) {
        if (p.value === 'NA' || p.value === null) {
          data.column['NA'].value++;
        }
      });

      if (data.column['NA'].value) {
        // console.log(data);
        // console.log('extent :',extent);
        data.column['NA'].perc = data.column['NA'].value / data.column.patients.length;
        //data.column['NA'].height = data.column['NA'].perc * D3PP.graphProps.graph.columns.height;
        data.column['NA'].height = 16;
        data.column['NA'].y = D3PP.graphProps.graph.columns.height - data.column['NA'].height;
        //data.column['NA'].yMean = data.column['NA'].y + (data.column['NA'].height / 2);
        data.column['NA'].yMean = data.column['NA'].y + data.column['NA'].height / 2 + 6;
      }

      data.column.extent = extent;

      data.column.scaleY = d3.scaleLinear();
      if (data.scale.type === 'log(10)') data.column.scaleY = d3.scaleLog();

      data.column.scaleY.domain(data.column.extent)
      //.range([(D3PP.graphProps.graph.columns.height - data.column['NA'].height), 0])
      .range([D3PP.graphProps.graph.columns.height - data.column['NA'].height, 0]).nice();

      if (data.scale.domain && data.scale.domain !== 'extent') {
        data.column.scaleY.domain(data.scale.domain);
      }

      //update for Kobi
      var domain = data.column.scaleY.domain();

      // Set Numiric NA Value
      // if (data.column['NA'].value) {
      //   console.log(data.column.scaleY.domain());
      //   console.log(data.column.scaleY.ticks());

      //   let ticks=data.column.scaleY.ticks();
      //   let newMax=domain[domain.length-1];
      //   let newMin=domain[0]-ticks[1];

      //   let domainNew=[newMin, newMax];
      //   console.log('domainNew ',domainNew);

      //   data.column.scaleY.domain(domainNew);
      //   domain = data.column.scaleY.domain();

      //   data.column['NA'].parseNumber=domain[0];

      //   console.log('data.column[NA] :',data.column['NA']);

      // }

      if (data.filters) {
        if (data.filters.brush) {
          if (data.filters.brush[0] < domain[0]) data.filters.brush[0] = domain[0];
          if (data.filters.brush[1] > domain[1]) data.filters.brush[1] = domain[1];
        }
      }

      //outlier detection
      //D3PP.validationWarnings.patientIsOutlier=false;
      var outLier = false;
      if (D3PP.activePatient) {
        var activePatient = data.column.patientsIdMap[D3PP.activePatient.features.patientID];
        if (activePatient.value < domain[0] || activePatient.value > domain[1]) {
          if (!D3PP.validationWarnings.patientIsOutlier) D3PP.validationWarnings.patientIsOutlier = { warning: true, columns: {} };
          D3PP.validationWarnings.patientIsOutlier.columns[data.column.id] = data.column.id;
          outLier = true;
        }

        if (outLier && data.filters) {
          data.filters.brush[0] = activePatient.value;
          data.filters.brush[1] = activePatient.value;
        }
      };

      if (data.scale.scaling === 'continuous') {
        data.resetFliterBtn.action = 'resetBrush';
        if (data.scale.violin) {

          if (!data.column.violinData) {
            data.resetFliterBtn.action = 'resetBrush';

            var _domain = data.column.scaleY.domain();

            var thresholds = [];
            for (var i = _domain[0]; i <= _domain[1]; i += data.scale.binSize) {
              thresholds.push(i);
            }
            ;

            var histogram = d3.histogram().value(function (d) {
              return d.value;
            }).domain(data.column.scaleY.domain()).thresholds(thresholds);

            data.column.violinData = histogram(data.column.patients);

            var max = d3.max(data.column.violinData, function (d) {
              d.mean = d.x0 + (d.x1 - d.x0) / 2;
              return d.length;
            });

            data.column.violinScaleX = d3.scaleLinear().range([-D3PP.graphProps.graph.columns.width, D3PP.graphProps.graph.columns.width]).domain([-max, max]);
          }
        }
        ;
      }
      ;
    } else {
      data.resetFliterBtn.action = 'resetColumnFilters';
      data.dataCategories = [];

      _.each(data.column.categories, function (d, i) {
        d.columnID = data.column.id;
        d.columnHeader = data.header;
        data.dataCategories.push(d);
      });

      //order options here
      if (!data.scale.order || data.scale.order === 'category') {
        // category is the default, if not configured
        data.dataCategories = _.sortBy(data.dataCategories, function (o) {
          return o.category;
        });
      } else if (data.scale.order === 'value') {
        data.dataCategories = _.sortBy(data.dataCategories, function (o) {
          return o.value;
        });
      } else if (data.scale.order === 'binair') {
        data.dataCategories = _.sortBy(data.dataCategories, function (o) {
          return o.category;
        });
      } else if (data.scale.order.range) {

        _.each(data.scale.order.range, function (o, i) {
          var c = _.find(data.dataCategories, function (cat) {
            return o === cat.category;
          });
          if (c) c.order = i;
        });
        data.dataCategories = _.sortBy(data.dataCategories, function (o) {
          return o.order;
        });
      };

      data.dataCategories.reverse();

      //always put NA on bottom
      var catNA = _.find(data.dataCategories, function (o) {
        return o.category === 'NA';
      });
      if (catNA) {
        var newList = _.remove(data.dataCategories, function (o) {
          return o.category === 'NA';
        });
        data.dataCategories.push(catNA);
      }

      var catUnknown = _.find(data.dataCategories, function (o) {
        return o.category === 'Unknown';
      });
      if (catUnknown) {
        var _newList = _.remove(data.dataCategories, function (o) {
          return o.category === 'Unknown';
        });
        data.dataCategories.push(catUnknown);
      }
    }
  };

  D3PP.updateColumnProperties = function (data, index, vertexUpdate, bandWidth) {

    if (D3PP.graphType === 'sankey') ppPathsRender.getSankeyProps(data, D3PP.dataParallelPlot, D3PP.similarPatientsFilter, index, D3PP.graphProps);

    if (!data.column.categories) {
      data.similarCount = 0;
      if (D3PP.similarPatientsFilter.brushedPatients[data.column.id]) {
        data.resetFliterBtn.visibility = 'visible';
        data.similarCount = D3PP.similarPatientsFilter.brushedPatients[data.column.id].length;
      }

      if (vertexUpdate) {

        _.each(data.column.patients, function (p) {

          p.vertex = { x: data.column.x, y: data.column.scaleY(p.value), column: data.column.id };
          var px = p.vertex;
          var patient = D3PP.patientsIdMap[p.patientID];

          patient.paralelPlot.path = _.filter(patient.paralelPlot.path, function (p) {
            return p.column !== data.column.id;
          });

          if (p.value === 'NA' || p.value === null) {
            p.vertex.y = data.column.NA.yMean;
            var p0 = {
              x: data.column.x - D3PP.graphProps.graph.columns.width / 2,
              y: data.column.NA.yMean,
              column: data.column.id
            };
            var p1 = {
              x: data.column.x + D3PP.graphProps.graph.columns.width / 2,
              y: data.column.NA.yMean,
              column: data.column.id
            };
            patient.paralelPlot.path.push(p0);
            patient.paralelPlot.path.push(p1);
          };

          patient.paralelPlot.path.push(p.vertex);
        });
      }
      data.metricLabel = '';
      if (data.similarCount > 0) data.metricLabel = (D3PP.similarPatientsFilter.patients.length / D3PP.totalNRPatients * 100).toFixed(1) + '% (' + D3PP.similarPatientsFilter.patients.length + ')';
    } else {

      if (D3PP.similarPatientsFilter.columnPatients[data.column.id]) data.resetFliterBtn.visibility = 'visible';

      _.each(data.dataCategories, function (d, i) {

        d.percentage = d.patients.length / D3PP.totalNRPatients;
        d.similarCount = 0;

        d.height = d.percentage * D3PP.graphProps.graph.columns.height;
        if (i === 0) {
          d.y = 0;
        } else {
          d.y = data.dataCategories[i - 1].y + data.dataCategories[i - 1].height;
        }
        d.yMean = d.y + d.height / 2;

        if (i === 0) data.similarCount = 0;

        _.each(d.patients, function (p) {

          if (vertexUpdate) {

            p.vertex = { x: data.column.x, y: d.yMean, column: data.column.id };

            var px = p.vertex;
            var p0 = {
              x: data.column.x - D3PP.graphProps.graph.columns.width / 2,
              y: d.yMean,
              column: data.column.id
            };
            var p1 = {
              x: data.column.x + D3PP.graphProps.graph.columns.width / 2,
              y: d.yMean,
              column: data.column.id
            };

            var patient = D3PP.patientsIdMap[p.patientID];

            patient.paralelPlot.path = _.filter(patient.paralelPlot.path, function (p) {
              return p.column !== d.columnID;
            });

            patient.paralelPlot.path.push(px);
            patient.paralelPlot.path.push(p0);
            patient.paralelPlot.path.push(p1);
          }

          if (D3PP.similarPatientsFilter.patientsIdMap[p.patientID]) d.similarCount++;
        });

        d.filtersActive = D3PP.similarPatientsFilter.filtersActive;
        d.similarPercentageCategory = d.similarCount / d.nrPatients;
        d.similarPercentage = d.similarCount / D3PP.totalNRPatients;
        d.heightSimilar = d.similarCount / d.nrPatients * d.height;
        d.metricLabel = (d.percentage * 100).toFixed(0) + '%';

        if (D3PP.similarPatientsFilter.patients.length === 0) {
          d.metricLabel = (d.percentage * 100).toFixed(0) + '% (' + d.nrPatients + ')';;
        } else {
          d.metricLabel = (d.similarPercentage * 100).toFixed() + '% (' + d.similarCount + ')';
          if (d.similarPercentageCategory === 0) {
            d.metricLabel = '0%';
          }
        }

        d.labelPosY = d.yMean;
        if (i > 0) {
          if (d.labelPosY < data.dataCategories[i - 1].labelPosY + 14) {
            d.labelPosY = data.dataCategories[i - 1].labelPosY + 14;
          }
        }

        if (D3PP.graphType === 'sankey') {
          d.height = d.percentage * data.columnHeight;
          if (i === 0) {
            data.similarCount = 0;
            d.y = data.baseY;
          } else {
            d.y = data.dataCategories[i - 1].y + data.dataCategories[i - 1].height;
          }
          d.yMean = d.y + d.height / 2;

          ppPathsRender.setRelations(D3PP.dataParallelPlot, D3PP.similarPatientsFilter, d, index, D3PP.graphProps, bandWidth);
        }
      });
    }
  };

  D3PP.updateColumns = function (tweenTime, columnUpdate, vertexUpdate) {

    _.each(D3PP.dataParallelPlot, function (d, i) {
      d.column.x = D3PP.scaleX(d.column.id) + D3PP.graphProps.global.margins.offSetX;
      d.column.width = D3PP.graphProps.graph.columns.width;
      if (d.distributed) d.column.distributed = true;
      d.resetFliterBtn.visibility = 'hidden';
      D3PP.updateColumnProperties(d, i, vertexUpdate, D3PP.scaleX.bandwidth());
    });

    var gColumns = D3PP.svg.gGraph.columns.selectAll('#gColumn').data(D3PP.dataParallelPlot, function (d) {
      return d.column.id;
    });

    gColumns.enter().append('g').attr('id', 'gColumn').attr('key', function (d) {
      return d.column.id;
    }).attr('class', 'pp-svg-columns').attr("transform", function (d, i) {
      return "translate(" + d.column.x + "," + 0 + ")";
    }).attr('opacity', function () {
      var opacity = 1;
      if (D3PP.interval) opacity = 0;
      return opacity;
    }).each(function (d, i) {

      var g = d3.select(this);

      g.append('text').attr('id', 'header').attr('class', 'header');

      g.append('rect').attr('id', 'header-overlay').attr('x', -D3PP.graphProps.graph.columns.innerPadding / 2).attr('opacity', 0).attr('cursor', 'ew-resize').on('mousedown', function () {
        D3PP.onDragAllowed = true;
      });

      if (d.resetFliterBtn.action === 'resetBrush') D3PP.setHtmlInputs(g, d);

      var gReset = g.append('g').attr('id', 'btn-reset-filters').attr('key', d.column.id).attr('transform', "translate(" + 0 + "," + (D3PP.graphProps.graph.columns.height + 10) + ")").attr('cursor', 'pointer').attr('visibility', d.resetFliterBtn.visibility).on('click', function () {
        if (d.resetFliterBtn.action === 'resetBrush') {
          D3PP.resetColumnBrush(d.column.id);
        } else {
          D3PP.resetColumnFilters(d.dataCategories, false, tweenTime);
        }
      }).on('mouseover', function () {
        d3.select(this).select('rect').attr('fill', '#BFE2EB');
      }).on('mouseout', function () {
        d3.select(this).select('rect').attr('fill', drawUtils.colors.similarPatients.default);
      });

      gReset.append('rect').attr('width', 104).attr('height', 20).attr('x', -52).attr('y', 8).attr('rx', 3).attr('ry', 3).attr('fill', drawUtils.colors.similarPatients.default);

      gReset.append('text').attr('class', 'btn-reset-filter').attr('font-size', 10).attr('font-weight', 400).attr('text-anchor', 'middle').attr('fill', '#fff').attr('y', 20).text('Clear Filters');

      columnCategoriesUpdate(g, d);
    }).call(d3.drag().subject(function (d) {
      return { x: d.column.x };
    }).on("start", function (d) {
      if (D3PP.onDragAllowed) {
        D3PP.svg.gGraph.trash.transition().duration(100).attr("transform", "translate(" + D3PP.graphProps.graph.trash.xActive + "," + D3PP.graphProps.graph.trash.y + ")");
        d.dragging = true;
      }
    }).on("drag", function (d) {
      D3PP.updateColumnPropertiesDragPosition('drag', d3.event, d.column.id, 0);
    }).on("end", function (d) {
      d.dragging = false;
      D3PP.updateColumnPropertiesDragPosition('end', d3.event, d.column.id, 250);
      D3PP.svg.gGraph.trash.transition().duration(100).attr("transform", "translate(" + D3PP.graphProps.graph.trash.xInActive + "," + D3PP.graphProps.graph.trash.y + ")");
    }));

    gColumns.each(function (d, i) {
      var g = d3.select(this);
      D3PP.setColumnHeader(d, i, g.select('#header'), g.select('#header-overlay'));

      g.select('#btn-reset-filters').attr('visibility', d.resetFliterBtn.visibility);

      columnCategoriesUpdate(g, d);
    });

    gColumns.transition().duration(tweenTime).attr("transform", function (d) {
      return "translate(" + d.column.x + "," + 0 + ")";
    });

    gColumns.exit().remove();

    function columnCategoriesUpdate(_g, data) {
      if (!columnUpdate) return;
      if (data.dataCategories) {
        categoryColumn.updateColumn(_g, data, tweenTime, D3PP.showToolTip, D3PP.toolTipPosition, D3PP.removeToolTip, D3PP.updateColumnsFilterSelection, D3PP.onDragAllowed);
      } else {
        continuousColumn.updateColumn(_g, data, tweenTime, D3PP.setBrush, D3PP.similarPatientsFilter);
      }
    }

    // set column pre filter configuration
    if (!D3PP.preFilterConfigurations.inited) {
      _.each(D3PP.preFilterConfigurations.categories, function (d) {
        d.selected = false;
      });

      D3PP.updateColumnsFilterSelection(D3PP.preFilterConfigurations.categories, tweenTime);

      _.each(D3PP.preFilterConfigurations.brushes, function (d) {
        //check max boundaries domain
        if (d.filters.brush[0] < d.column.extent[0]) d.filters.brush[0] = d.column.extent[0];
        if (d.filters.brush[1] > d.column.extent[1]) d.filters.brush[1] = d.column.extent[1];

        var y0 = d.column.scaleY(d.filters.brush[1]);
        var y1 = d.column.scaleY(d.filters.brush[0]);
        D3PP.columnBrushes[d.column.id]['gBrush'].call(D3PP.columnBrushes[d.column.id].brush.move, [y0, y1]);
      });

      D3PP.preFilterConfigurations.brushes = [];
      D3PP.preFilterConfigurations.categories = [];

      D3PP.updateColumnsFilterSelection(D3PP.preFilterConfigurations.categories, tweenTime);
    };

    D3PP.updatePatients(tweenTime, vertexUpdate);

    D3PP.updateHeaderFooter();
  };

  D3PP.setColumnHeader = function (d, i, cHeaderNode, headerOverlayNode) {
    var y = -64 + i % 2 * 30;

    cHeaderNode.attr('y', y).attr('x', 0).text(d.header);
    headerOverlayNode.attr('y', y - 16);

    // wrap text if width exceeds maximum width
    drawUtils.computeTextNodeRect(cHeaderNode, 0, 150, [headerOverlayNode]);
  };

  D3PP.columnsToUpdate = null;
  D3PP.updateColumnPropertiesDragPosition = function (dragType, event, columnID, tweenTime) {

    if (!D3PP.columnsToUpdate) D3PP.columnsToUpdate = {};

    if (event.x <= 0 && dragType === 'drag') {
      return;
    };

    if (!D3PP.onDragAllowed) return;

    D3PP.svg.gGraph.svgSplines.attr('visibility', 'hidden');
    if (!D3PP.realTimeUpdate) D3PP.canvas.style('opacity', 0.25);

    var inTrash = false;
    D3PP.svg.gGraph.trash.attr('visibility', 'visible');
    var trashRect = D3PP.svg.gGraph.trash.select('#trash-rect');

    if (D3PP.dataParallelPlot[D3PP.dataParallelPlot.length - 1].column.x > D3PP.graphProps.graph.trash.xActive) {
      inTrash = true;
      trashRect.attr('fill', '#fff').attr('stroke-width', 3);
    } else {
      trashRect.attr('fill', '#f6f6f6').attr('stroke-width', 1);
    }

    if (dragType === 'end') {
      D3PP.svg.gGraph.trash.attr('visibility', 'hidden');
      trashRect.attr('fill', '#f6f6f6').attr('stroke-width', 1);
    };

    D3PP.dataParallelPlot = D3PP.dataParallelPlot.sort(function (a, b) {
      return a.column.x - b.column.x;
    });

    var xDomain = D3PP.dataParallelPlot.map(function (d) {
      return d.column.id;
    });
    D3PP.scaleX.domain(xDomain);

    var activeIndex = void 0;
    var columns = D3PP.svg.gGraph.columns.selectAll('#gColumn').data(D3PP.dataParallelPlot, function (d) {
      return d.column.id;
    });

    var activeColumn = void 0;
    columns.each(function (d, i) {
      d.order = i;
      if (d.column.id === columnID) activeIndex = i;

      var g = d3.select(this);
      d.column.x = D3PP.scaleX(d.column.id) + D3PP.graphProps.global.margins.offSetX;

      if (d.dragging) d.column.x = event.x;
      D3PP.setColumnHeader(d, i, g.select('#header').transition().duration(0, g.select('#header-overlay').transition().duration(0)));

      g.transition().duration(tweenTime).attr("transform", "translate(" + d.column.x + ")");
    });

    if (dragType === 'end' && inTrash) {
      _.each(D3PP.dataConfig.columns, function (d) {
        if (d.column.id === columnID) d.active = false;
      });

      D3PP.onColumnConfigUpdate(D3PP.dataConfig.columns);
    } else if (dragType === 'drag') {

      var columnsToUpdate = [];

      if (D3PP.dataParallelPlot[activeIndex - 1]) {
        columnsToUpdate.push(activeIndex - 1);
        D3PP.columnsToUpdate[D3PP.dataParallelPlot[activeIndex - 1].column.id] = D3PP.dataParallelPlot[activeIndex - 1];
      }

      columnsToUpdate.push(activeIndex);
      D3PP.columnsToUpdate[D3PP.dataParallelPlot[activeIndex].column.id] = D3PP.dataParallelPlot[activeIndex];

      if (D3PP.dataParallelPlot[activeIndex + 1]) {
        columnsToUpdate.push(activeIndex + 1);
        D3PP.columnsToUpdate[D3PP.dataParallelPlot[activeIndex + 1].column.id] = D3PP.dataParallelPlot[activeIndex + 1];
      }

      if (D3PP.realTimeUpdate) {
        _.each(columnsToUpdate, function (index) {
          D3PP.updateColumnProperties(D3PP.dataParallelPlot[index], index, true);
        });

        D3PP.updatePatients(tweenTime, true);
      }
    } else if (dragType === 'end' && !inTrash) {

      _.each(D3PP.columnsToUpdate, function (c) {
        D3PP.updateColumnProperties(c, c.order, true);
      });

      D3PP.updatePatients(tweenTime, true);
    }

    if (dragType === 'end') {
      D3PP.svg.gGraph.svgSplines.attr('visibility', 'visible');
      D3PP.canvas.style('opacity', 1);
      D3PP.columnsToUpdate = null;
    }
  };

  D3PP.resetColumnFilters = function (categories, tweenTime) {

    _.each(categories, function (d, i) {
      d.selected = false;
      if (D3PP.similarPatientsFilter.columnSelection[d.columnID]) delete D3PP.similarPatientsFilter.columnSelection[d.columnID];
      if (D3PP.similarPatientsFilter.columnPatients[d.columnID]) delete D3PP.similarPatientsFilter.columnPatients[d.columnID];
    });

    D3PP.setSimilarPatientsFilter(false, tweenTime, true);
  };

  D3PP.setBrush = function (_g, data) {

    D3PP.columnBrushes[data.column.id] = {};

    D3PP.columnBrushes[data.column.id]['brush'] = d3.brushY().extent([[-6, 0], [6, D3PP.graphProps.graph.columns.height - data.column.NA.height]]).on("brush", function () {

      if (D3PP.realTimeUpdate) {
        var brushedColumn = _.find(D3PP.dataParallelPlot, function (d) {
          return d.column.id === data.column.id;
        });
        continuousColumn.brushed(_g, data.column.id, brushedColumn, D3PP.similarPatientsFilter);
        D3PP.setSimilarPatientsFilter(false, 0, false);
      }
    }).on("end", function (d) {

      if (d.brushIsRounded) {
        d.brushIsRounded = false;
        d3.event.sourceEvent = null;
      }

      var brushedColumn = _.find(D3PP.dataParallelPlot, function (c) {
        return c.column.id === data.column.id;
      });

      if (d3.event.sourceEvent && d3.event.selection && d.scale.units.type === 'int') {

        var rawValues = d3.event.selection.map(data.column.scaleY.invert);

        if (!Number.isInteger(rawValues[0]) || !Number.isInteger(rawValues[1])) {
          var roundedValues = rawValues.map(function (d) {
            return parseInt(Math.round(d));
          });
          var brushValues = roundedValues.map(function (d) {
            return data.column.scaleY(d);
          });
          brushValues.sort(function (a, b) {
            return a - b;
          });
          d.brushIsRounded = true;
          D3PP.columnBrushes[data.column.id]['gBrush'].call(D3PP.columnBrushes[data.column.id].brush.move, brushValues);
          return;
        };
      };

      continuousColumn.brushed(_g, data.column.id, brushedColumn, D3PP.similarPatientsFilter);
      continuousColumn.brushEndend(data.column.id, D3PP.similarPatientsFilter);
      D3PP.setSimilarPatientsFilter(false, 0, true);
    });

    D3PP.columnBrushes[data.column.id]['gBrush'] = _g.append("g").attr('key', data.column.id).attr("class", "brush").on("dblclick", function () {
      D3PP.resetColumnBrush(data.column.id);
    }).call(D3PP.columnBrushes[data.column.id].brush);
  };

  D3PP.setHtmlInputs = function (_g, data) {

    data.brushProps = {};
    data.brushProps.domain = data.column.scaleY.domain();
    var step = data.brushProps.domain[1] - data.brushProps.domain[0];

    if (step <= 1) {
      data.brushProps.stepper = 0.01;
    } else {
      data.brushProps.stepper = 1;
    }

    data.brushProps.digits = data.scale.units.digits;

    var min = Number(data.brushProps.domain[0].toFixed(data.brushProps.digits));
    var max = Number(data.brushProps.domain[1].toFixed(data.brushProps.digits));

    var dataInputs = [{ value: min, pos: 'left' }, { value: max, pos: 'right' }];

    var inputs = _g.selectAll('#html-brush-inputs').data(dataInputs);

    var offsetY = 28;
    if (D3PP.environment === 'ISPM') offsetY = 40;

    inputs.enter().append("foreignObject").attr('id', 'html-brush-inputs').attr('key', data.column.id).attr("width", 48 + 'px').attr("height", 48 + 'px').attr('x', function (d, i) {
      var x = -48 - 4;
      if (i > 0) x = 4;
      return x;
    }).attr('y', D3PP.graphProps.graph.columns.height + offsetY).attr('visibility', 'hidden').each(function (d, i) {
      var fObject = d3.select(this);
      var key = 'inputMin';
      if (i === 1) key = 'inputMax';

      fObject.append("xhtml:p").html('<input class="brush-input" type="number" min=' + min + ' max=' + max + ' step=' + data.brushProps.stepper + ' value=' + d.value + ' id="brushValue" key=' + key + ' maxlength="8">');

      fObject.select('.brush-input').on('change', function (i) {
        d.value = Number(this.value);
        this.value = d.value;
        D3PP.updateBrushInputs(_g, data.column.id, data.column.scaleY, key);
      }).on('keydown', function (event) {
        this.whileKeyPress = true; // mark that value is changed during a key-press
      }).on('keyup', function (event) {
        this.whileKeyPress = false; // stop marking the key-press event
      }).on('input', function (event) {

        // if value is NOT changed while typing (but while pressing the arrows) force a lost-focus event to stop
        //  the infinite scrolling (see: GEN-86174)
        if (!this.whileKeyPress) {
          this.blur();
        }
      });
    });
  };

  D3PP.updateBrushInputs = function (_g, columnID, scaleY, inputType) {

    var htmlInputs = _g.selectAll('#html-brush-inputs').attr('visibility', 'visible');

    var inputElements = [];
    htmlInputs.each(function (d, i) {
      var fObject = d3.select(this);
      inputElements.push({ item: fObject.select('#brushValue'), value: d.value });
    });

    var minInput = inputElements[0].value;
    var maxInput = inputElements[1].value;

    var domain = scaleY.domain();
    var minInputInvalid = minInput > maxInput || minInput < domain[0] || minInput > domain[1];
    var maxInputInvalid = maxInput < minInput || maxInput < domain[0] || maxInput > domain[1];

    var isInputInvalid = void 0;
    var inputElement = void 0;
    if (inputType === 'inputMin') {
      isInputInvalid = minInputInvalid;
      inputElement = inputElements[0].item;
    } else {
      isInputInvalid = maxInputInvalid;
      inputElement = inputElements[1].item;
    }

    var outlineColor = '#1474A4';
    var border = '1px solid #212121';
    var color = '#212121';

    if (isInputInvalid) {
      outlineColor = 'orange';
      border = '2px solid orange';
      color = 'orange';
    }

    inputElement.style('outline-color', outlineColor).style('border', border).style('color', color);

    if (minInputInvalid || maxInputInvalid) {

      if (!D3PP.validationWarnings.invalidInput) {
        // if invalid indication had changed
        D3PP.validationWarnings.invalidInput = true;
        D3PP.updateValidationWarnings();
      }

      return;
    }

    var brushRange = inputElements.map(function (d) {
      return scaleY(d.value);
    });
    D3PP.updateColumnBrush(columnID, [brushRange[1], brushRange[0]], false);
  };

  D3PP.resetColumnBrush = function (columnID) {
    D3PP.updateColumnBrush(columnID, null, false);
  };

  D3PP.updateColumnBrush = function (columnID, brushRange, invalidInput) {
    D3PP.validationWarnings.invalidInput = invalidInput;

    D3PP.columnBrushes[columnID]['gBrush'].call(D3PP.columnBrushes[columnID].brush.move, brushRange);
  };

  D3PP.updateColumnsFilterSelection = function (filters, tweenTime) {

    _.each(filters, function (d) {

      if (!d.selected) {
        d.selected = true;
      } else {
        d.selected = false;
      }
      var sp = { column: d.columnID, category: d.category, patients: d.patients };
      if (d.selected) {
        if (!D3PP.similarPatientsFilter.columnSelection[d.columnID]) D3PP.similarPatientsFilter.columnSelection[d.columnID] = {};
        D3PP.similarPatientsFilter.columnSelection[d.columnID][d.category] = sp;
      } else {
        delete D3PP.similarPatientsFilter.columnSelection[d.columnID][d.category];
      }
    });

    D3PP.similarPatientsFilter.columnPatients = {};
    _.each(D3PP.similarPatientsFilter.columnSelection, function (filter, column) {
      _.each(filter, function (cat) {
        if (!D3PP.similarPatientsFilter.columnPatients[column]) D3PP.similarPatientsFilter.columnPatients[column] = [];
        D3PP.similarPatientsFilter.columnPatients[column] = _.concat(D3PP.similarPatientsFilter.columnPatients[column], cat.patients);
      });
    });

    D3PP.setSimilarPatientsFilter(false, tweenTime, true);
  };

  D3PP.setSimilarPatientsFilter = function (vertexUpdate, tweenTime, reportUpdate) {

    var filterProps = filterHandler.setSimilarPatientsFilter(D3PP.dataParallelPlot, D3PP.similarPatientsFilter, D3PP.activePatient, D3PP.validationWarnings, D3PP.environment);

    D3PP.similarPatientsFilter = filterProps.similarPatientsFilter;
    D3PP.validationWarnings = filterProps.validationWarnings;

    var props = {
      data: D3PP.similarPatientsFilter,
      filtersActive: D3PP.similarPatientsFilter.filtersActive,
      updateType: 'filter',
      vertexUpdate: vertexUpdate,
      reportUpdate: reportUpdate,
      tweenTime: tweenTime,
      validationWarnings: D3PP.validationWarnings
    };

    //Update and check pre filter configurations
    if (!D3PP.preFilterConfigurations.inited) {
      if (D3PP.preFilterConfigurations.categories.length === 0 && D3PP.preFilterConfigurations.brushes.length === 0) {
        D3PP.preFilterConfigurations.inited = true;
        console.log('inited pre filter configurations');
        D3PP.onFilterUpdate(props, true); // true means no rdAjaxCallback
      }
    } else {
      D3PP.onFilterUpdate(props, false);
    }
  };

  D3PP.updatePatients = function (tweenTime, vertexUpdate) {

    var props = void 0;
    if (D3PP.graphType === 'parallelPlot') {
      props = {
        activePatient: D3PP.activePatient,
        patientsIdMap: D3PP.patientsIdMap,
        similarPatientsFilter: D3PP.similarPatientsFilter,
        totalNRPatients: D3PP.totalNRPatients,

        virtualDomContainer: D3PP.virtualDomContainer,
        gSvgSplines: D3PP.svg.gGraph.svgSplines,

        canvas: D3PP.canvas,
        context: D3PP.context,

        tweenTime: tweenTime,
        vertexUpdate: vertexUpdate
      };
    } else {
      props = {
        gCatRelations: D3PP.svg.gGraph.catRelations,
        dataParallelPlot: D3PP.dataParallelPlot,
        categoryColumn: categoryColumn,
        tweenTime: tweenTime
      };
    }

    ppPathsRender.updatePatients(props);
  };

  D3PP.updateHeaderFooter = function () {

    var nrSimilar = D3PP.similarPatientsFilter.patients.length;
    var percSimilar = (nrSimilar / D3PP.totalNRPatients * 100).toFixed(1);
    var labelHeader = 'No Filters Applied';
    var labelSubHeader = 'Population ' + D3PP.totalNRPatients + ' patients';

    if (nrSimilar > 0) {
      labelHeader = 'Analytic Filters Results: ' + percSimilar + '%' + ' | n=' + nrSimilar;
    }

    //if(nrSimilar===0 && D3PP.similarPatientsFilter.filtersActive) labelSimilar='No Patients in Filter Selections';

    var header = D3PP.svg.gGraph.gHeader.selectAll('#header').data([labelHeader]);
    header.enter().append('text').attr('id', 'header').attr('class', 'svg-header').text(function (d) {
      return d;
    });

    header.text(function (d) {
      return d;
    });

    var header_sub = D3PP.svg.gGraph.gHeader.selectAll('#sub_header').data([labelSubHeader]);
    header_sub.enter().append('text').attr('id', 'sub_header').attr('class', 'svg-header-sub').attr('y', 20).text(function (d) {
      return d;
    });

    header_sub.text(function (d) {
      return d;
    });

    D3PP.updateValidationWarnings();
  };

  D3PP.updateValidationWarnings = function () {

    var validationWarnings = {
      patientIsOutlier: 'Current patient is an outlier',
      patientIsOutFilterSelection: 'Data presented is not relevant for the selected patient',
      sampleSizeTooSmall: 'Selected sample size is too small',
      invalidInput: 'Invalid input value'
    };

    if (D3PP.dataConfig.localTextAPI) {
      var defWarnings = validationWarnings;
      validationWarnings = D3PP.dataConfig.localTextAPI.validationWarnings;

      // add all default messages that are not provided in the localTextAPI configuration
      _.forEach(Object.entries(defWarnings), function (warn) {
        var key = warn[0];
        if (!validationWarnings.hasOwnProperty(key)) {
          validationWarnings[key] = defWarnings[key];
        }
      });
    }

    var validations = [];
    var index = 0;
    _.each(D3PP.validationWarnings, function (w, key) {
      if (w) {

        // if message has parameters, interpolate all parameters into the message
        var warnMsg = validationWarnings[key];
        var warnParams = D3PP.validationWarnings[key]['params'];

        if (warnParams) {
          _.forEach(Object.entries(warnParams), function (param) {
            warnMsg = warnMsg.replaceAll('$(' + param[0] + ')', param[1]); // replace all occurrences of the parameter's placeholder
          });
        }

        var o = { warning: warnMsg, x: 0, y: 30, h: 28 };
        validations.push(o);
        index++;
      }
    });

    d3Warning.updateWarnings(D3PP.svg.gGraph.gHeader, validations, D3PP.environment);
  };

  D3PP.showToolTip = function (data, path) {

    var label = void 0;
    if (path) {

      var tooltipLabel = data.features.patientID;
      if (data.features.name && data.features.name.tooltipLabel) {
        tooltipLabel = data.features.name.tooltipLabel; // use the specific patient's label, if is defined
      }

      label = '<span style="font-size:14px; font-weight:600;" >' + tooltipLabel + '</span>' + '<br><br>';

      _.each(D3PP.dataParallelPlot, function (d) {
        var featureVal = data.features[d.column.id];
        var ttValue = Number(featureVal);

        if (!isNaN(ttValue)) {

          // check if value is float or int
          var intVal = Math.floor(ttValue);
          featureVal = ttValue == intVal ? intVal : ttValue.toFixed(2);

          // extract the display unit and check if column's unit is percent
          var unit = _.get(d, 'scale.units.metric');
          if (unit) unit = unit.toLowerCase();
          if (unit === 'percent' || unit === 'percentage') {
            featureVal = featureVal + '%';
          }
        }

        label += '<span style="font-size:12px; font-weight:400; line-height:1.6;" >' + d.header + ': ' + featureVal + '</span>' + '<br>';
      });
    } else {
      label = '<span style="font-size:14px; font-weight:400;" >' + data.columnHeader + ' | Category :' + data.category + '</span>' + '<br><br>';
      label += '<span style="font-size:12px; font-weight:400;" >Population ' + (data.percentage * 100).toFixed(2) + '% | ' + data.patients.length + '</span>' + '<br><br>';
      label += '<span style="font-size:12px; font-weight:400;" >Similar Patients ' + (data.similarPercentage * 100).toFixed(2) + '% | ' + data.similarCount + '</span>' + '<br><br>';
    }

    toolTipHandler.addMinimalContent(label, D3PP.toolTip, D3PP.environment);
    D3PP.toolTipPosition();
  };

  D3PP.toolTipPosition = function () {
    toolTipHandler.position(D3PP.toolTip, d3.event, D3PP.environment);
  };

  D3PP.removeToolTip = function (globalClick) {
    toolTipHandler.remove(D3PP.toolTip);
  };

  D3PP.parseLabelValue = function (value, digits) {
    value = value.toFixed(digits);
    var check = value.split('.');
    if (check[1] === '00') value = check[0];
    return value;
  };

  D3PP.toggleChartsVisibility = function (direction) {

    var showGraph = 'block';
    if (direction === 'up') {
      showGraph = 'none';
    }

    d3.select("#container-paralellplot").style('display', showGraph);

    d3.select("#container-similar-patients-info").style('display', showGraph);
  };

  return D3PP;
}

module.exports = d3ParallelPlot;